module.exports = "/_next/static/images/dwp-x-monstore_dark-3bd38046d682175e66dad50b81a987d6.png";